// components/ThemeWrapper.js
import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import getTheme from './theme';
import { DirectionProvider, useDirection } from './Context/DirectionContext';

const InnerThemeWrapper = ({ children }) => {
  const { direction, emotionCache } = useDirection();
  const theme = useMemo(() => getTheme(direction), [direction]);

  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </CacheProvider>
  );
};

const ThemeWrapper = ({ children }) => (
  <DirectionProvider>
    <InnerThemeWrapper>{children}</InnerThemeWrapper>
  </DirectionProvider>
);

export default ThemeWrapper;